import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'webpUrl',
  standalone: true
})
export class WebpUrlPipe implements PipeTransform {
  transform(url: string | null): string | null {
    if (!url) {
      return null;
    }

    // Replace .jpg, .jpeg, or .png with .webp
    return url.replace(/\.(jpe?g|png)$/i, '.webp');
  }
}
